export default __webpack_public_path__ + "static/AGaramondPro-BoldItalic-9836fee0c32063652254d82ff2be1e41.otf";